module.exports = __webpack_public_path__ + "img/wash.4b49c0b2.jpg";